export class OptimizedMix {
  static isLocked(activePlan: any) {
    return (
      activePlan?.basedOn?.optimizedForOfferId !== null &&
      (activePlan?.purchasePlanningLevel === 'PARTNER_LEVEL_PLANNING' ||
        activePlan?.purchasePlanningLevel === 'GROUP_LEVEL_PLANNING') &&
      (activePlan?.mixStatus === 'UNMODIFIED' ||
        activePlan?.mixStatus === 'PUBLISHED')
    );
  }
}
